exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select-recurso {\n  background-color: RGB(0, 117, 234, 0.16);\n  border-left: 1px solid RGBA(0, 0, 0, 0.50);\n  border-right: 1px solid RGBA(0, 0, 0, 0.50);\n  border-bottom: 1px solid RGBA(0, 0, 0, 0.50);\n  padding: 0px;\n  position: fixed;\n  z-index: 10;\n  width: 100%;\n  height: auto;\n}\n.ul :hover {\n  background: #0075EA\n}\nul, ol {\n  padding-left: 12px;\n  margin-bottom: 0px !important;\n}\n", ""]);

// exports
